import React, { useContext, useState, useEffect } from "react";
import noFolderLogo from "../images/sad.png";
import folderLogo from "../images/folderLogo.png";
import { UploadContext } from "./UploadContext";
import { useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import {
  addFolder,
  incrementCounter,
  incrementFCounter,
  removeLastFolder,
  decrementFCounter,
  resetFCounter,
} from "../store/fileSlicer";
import { ChakraProvider, Stack, useToast } from "@chakra-ui/react";
import axios from "axios";
function CopyFilePopup({ moveKey, source, onClose, files }) {
  const { addUpload, updateUploadProgress, removeUpload } =
    useContext(UploadContext);

  const [isRadioChecked, setIsRadioChecked] = useState(false);
  const [locationPath, setLocationPath] = useState("");
  const apiUrl = process.env.REACT_APP_API_ENDPOINT;
  const token = sessionStorage.getItem("number");
  const folderList = useSelector((state) => state.getdata.folderList);
  console.log("FolderList from copyfilepopuo", folderList);
  const rootFolderList = useSelector((state) => state.getdata.rootFolderList);
  const sharedFolderList = useSelector(
    (state) => state.getdata.sharedFolderList
  );
  console.log("rootFolderList", rootFolderList);
  console.log("sharedFolderList", sharedFolderList);
  const filenameRedux = useSelector((state) => state.getdata.fileName);
  const isSharedValue = useSelector((state) => state.getdata.isSharedValue);
  const counter = useSelector((state) => state.getdata.folderCounter);
  const counter2 = useSelector((state) => state.getdata.counter);
  console.log("counter : ", counter2);
  const counterPrime = counter;
  const counterPrime2 = counter2;
  console.log("counter : ", counter);
  const dispatch = useDispatch();
  console.log("moveKey is", moveKey);
  const sourceFol = source.replace(/\/$/, "");
  console.log("soruce", sourceFol);
  const [selectedPath, setSelectedPath] = useState(null);

  useEffect(() => {
    dispatch(resetFCounter()); // Reset folderCounter to 0 when modal opens
    openingActivities();
  }, []); // Empty dependency array ensures this runs only once when the component mounts

  function getTextAfterSlashes(text, counter) {
    const parts = text.split("/");

    // Ensure counter is within bounds
    if (counter >= parts.length) {
      return parts[parts.length - 1]; // Return the last segment if counter is too high
    }

    return parts.slice(counter).join("/");
  }

  function getTextAfterLastSlash(text) {
    const parts = text.split("/");

    return parts[parts.length - 1];
  }
  const key = getTextAfterLastSlash(moveKey);
  const openingActivities = () => {};

  useEffect(() => {
    openingActivities();
  }, []);

  function getLastSegment(arr) {
    return arr.map((item) => item.substring(item.lastIndexOf("/") + 1));
  }

  const handleItemClick = async (path) => {
    console.log(path);
    try {
      const params = {
        folderPath: path,
        ...(isSharedValue && { shared: filenameRedux }),
      };

      const res = await axios.get(`${apiUrl}getFolder`, {
        params,
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      const folders = res.data.filter(
        (item) => item?.isFolder === true || item?.isFolder === "true"
      );
      console.log("Response data from folder moveFolderPopup is ", folders);

      // Update path for breadcrumb-style UI
      setLocationPath((prev) => {
        if (prev) {
          return `${prev} / ${getTextAfterSlashes(path, counter)}`;
        } else {
          return getTextAfterSlashes(path, counter);
        }
      });
      // Dispatch the folders array directly, not wrapped in another array
      dispatch(addFolder(folders));
      dispatch(incrementFCounter());
    } catch (error) {
      console.error("Error fetching folder data:", error);
    }
  };

  const handleMove = async () => {
    onClose();
  
    const uploadId = Date.now() + Math.random();
    const uploadIds = []; // Track all uploads added
  
    try {
      const sharedParams = isSharedValue ? { shared: filenameRedux } : {};
  
      let adjustedSourceFolder = sourceFol;
      if (isSharedValue && sourceFol === filenameRedux) {
        adjustedSourceFolder = "";
      } else if (isSharedValue && sourceFol.startsWith(`${filenameRedux}/`)) {
        adjustedSourceFolder = sourceFol.replace(`${filenameRedux}/`, "");
      }
  
      if (!Array.isArray(files)) {
        throw new Error("files is not an array");
      }
  
      let copiedAnything = false;
  
      // MULTIPLE FILES
      // MULTIPLE FILES
if (files.length > 0) {
  const sanitizedFiles = files.map((file) => file.trim().split("/").pop());
  sanitizedFiles.forEach((file) => {
    addUpload(uploadId, "Copying " + file);
    uploadIds.push(uploadId);
  });

  await axios.post(
    `${apiUrl}copy-file`,
    {
      destinationFolder: selectedPath,
      sourceFolder: adjustedSourceFolder,
      keys: sanitizedFiles,
    },
    {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      params: sharedParams,
      onUploadProgress: (progressEvent) => {
        const progress = Math.round(
          (progressEvent.loaded * 100) / progressEvent.total
        );
        updateUploadProgress(uploadId, progress);
      },
    }
  );
  copiedAnything = true;
}

  
      // SINGLE FILE
      if (key) {
        const singleUploadId = Date.now() + Math.random();
        const trimmedKey = key.trim().split("/").pop(); // ⬅️ Only filename
        addUpload(singleUploadId, "Copying " + trimmedKey);
        uploadIds.push(singleUploadId);
  
        await axios.post(
          `${apiUrl}copy-file`,
          {
            destinationFolder: selectedPath,
            sourceFolder: adjustedSourceFolder,
            keys: [trimmedKey],
          },
          {
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "application/json",
            },
            params: sharedParams,
            onUploadProgress: (progressEvent) => {
              const progress = Math.round(
                (progressEvent.loaded * 100) / progressEvent.total
              );
              updateUploadProgress(singleUploadId, progress);
            },
          }
        );
        copiedAnything = true;
      }
  
      // ✅ Show toast
      if (copiedAnything) {
        showToast("success", "File(s) copied successfully!");
      }
    } catch (error) {
      showToast("error", "Failed to copy file!");
      console.error("Error copying file:", error);
    } finally {
      // ⛔️ Always cleanup all upload entries
      uploadIds.forEach((id) => removeUpload(id));
      onClose();
    }
  };
  
  

  const handleBack = () => {
    console.log("Back Button Clicked");

    setIsRadioChecked(false);

    if (isSharedValue) {
      dispatch(decrementFCounter()); // If shared folder, decrement counter
      dispatch(removeLastFolder2());
    } else {
      dispatch(removeLastFolder()); // If normal folder, remove last folder
      dispatch(decrementFCounter()); // If shared folder, decrement counter
    }
    setLocationPath((prev) => {
      if (!prev.includes("/")) return ""; // if only one level left
      return prev.substring(0, prev.lastIndexOf(" / "));
    });
  };
  const toast = useToast();

  const showToast = (status, message) => {
    toast({
      title: `${status.charAt(0).toUpperCase() + status.slice(1)}`,
      description: message,
      status: status, // Set this to 'error' for a red-colored pop-up
      duration: 3000,
      isClosable: true,
    });
  };

  const handleClose = () => {
    dispatch(resetFCounter()); // Reset folderCounter to 0
    onClose(); // Call the existing close function
  };
  return (
    <>
      <ChakraProvider></ChakraProvider>
      <div className="popup-container">
        <div className="move-to-popup">
          <div className="move-to-modal">
            {/* Header */}
            <div className="move-to-header with-back">
              {counter > 0 && (
                <button className="back-button" onClick={handleBack}>
                  <i className="icon-arrow-left"></i> Back
                </button>
              )}
              <h3 className="move-to-title">Copy To</h3>
              <p className="move-to-location">
                Location : <span>{locationPath || ""}</span>
              </p>
            </div>

            {/* Scrollable Body */}
            <div className="move-to-body">
              <ul className="move-to-folder-list">
                {/* Root Folder Option */}
                {(counterPrime === 0 && !isSharedValue) ||
                (counterPrime === 0 && isSharedValue) ? (
                  <div
                  className={`folder-option ${
                    selectedPath === "" ? "selected" : ""
                  }`}
                 
                >
                  <label
                    className="custom-radio-wrapper"
                    onClick={(e) => e.stopPropagation()} // 👈 prevents bubbling up
                  >
                     <input
                  type="radio"
                  name="destination"
                  checked={selectedPath === ""}
                  onChange={() => {
                    setSelectedPath("");
                    setIsRadioChecked(true);
                  }}
                  onClick={(e) => e.stopPropagation()}
                />
                    <span className="custom-radio" style={{marginRight:"0"}}></span>
                  </label>
                  <img src={folderLogo} alt="Folder" />
                  {isSharedValue ? "SHARED ROOT FOLDER" : "Root Folder"}
                </div>
                ) : null}

                {/* Folder Items */}
                {(isSharedValue ? sharedFolderList : rootFolderList).length >
                0 ? (
                  Object.values(
                    (isSharedValue ? sharedFolderList : rootFolderList)[
                      (isSharedValue ? sharedFolderList : rootFolderList)
                        .length - 1
                    ]
                  )[0].map((item, index) => (
                    <div
                      className={`folder-option ${
                        selectedPath === item.fileName ? "selected" : ""
                      }`}
                      onClick={() => handleItemClick(item.fileName)}
                    >
                      <label
                        className="custom-radio-wrapper"
                        onClick={(e) => e.stopPropagation()} // 👈 prevents bubbling up
                      >
                        <input
                          type="radio"
                          name="destination"
                          checked={selectedPath === item.fileName}
                          onChange={() => {
                            setSelectedPath(item.fileName);
                            setIsRadioChecked(true);
                          }}
                        />
                        <span className="custom-radio" style={{marginRight:"0"}}></span>
                      </label>
                      <img src={folderLogo} alt="Folder" />
                      {getTextAfterSlashes(item.fileName, counter)}
                    </div>
                  ))
                ) : (
                  <div className="empty-state">
                    <img
                      src={noFolderLogo}
                      alt="No folder to show"
                      className="no-folder-icon"
                    />
                    <p>
                      No {isSharedValue ? "shared" : "root"} folders to show
                    </p>
                  </div>
                )}
              </ul>
            </div>

            {/* Footer */}
            <div className="move-to-footer">
              <button className="cancel-btn" onClick={handleClose}>
                Cancel
              </button>
              <button
                className="move-btn"
                onClick={handleMove}
                disabled={!isRadioChecked}
              >
                Copy
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
export default CopyFilePopup;
